import axios from 'axios';
import type { BadgeVariant } from '@/components/ui/Badge';

export const CONNECTIONS_PATH = '/connections';

/** Standalone Analysis page. Update this if the route changes. */
export const ANALYSIS_ROUTE = '/analysis';

export function apiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const detail = error.response?.data?.detail;
    if (typeof detail === 'string' && detail.trim()) return detail;
    if (detail && typeof detail === 'object' && 'message' in detail) {
      const message = (detail as { message?: unknown }).message;
      if (typeof message === 'string' && message.trim()) return message;
    }
    if (typeof error.message === 'string' && error.message.trim()) return error.message;
  }
  if (error instanceof Error && error.message.trim()) return error.message;
  return fallback;
}

export function statusVariant(status: string): BadgeVariant {
  if (status === 'succeeded' || status === 'sent') return 'success';
  if (status === 'failed') return 'danger';
  if (status === 'running' || status === 'queued' || status === 'pending') return 'warning';
  return 'neutral';
}

export function formatWhen(value: string | null): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
}
